import axios from '@/tools/axios/axios'
import { getUserTrackingData } from '@/tools/session'
import generateRequestHash from './client-graphql/generate-request-hash'
import convertVariablesToCacheableQueryString from './client-graphql/convert-variables-to-cacheable-query-string'

export function getOperationName(query) {
  const findQueryNameRegex = new RegExp('query [a-z]+', 'gmi')
  const [rawOperationName] = findQueryNameRegex.exec(query) || ['']

  const findQueryWordAndSpacesRegex = new RegExp(/\s|query/, 'gmi')

  return rawOperationName.replace(findQueryWordAndSpacesRegex, '')
}

export default class ClientGraphql {
  constructor({ endpoint }) {
    this.endpoint = endpoint
  }

  fetch({ query, variables = {}, endpointModifier = null, cancelToken }) {
    const options = {
      query,
      variables,
      endpointModifier,
      operationName: getOperationName(query),
      requestHash: generateRequestHash(query, variables),
      cancelToken
    }

    return new Promise((resolve, reject) => {
      this.makeRequestWithHash(options)
        .then(response => {
          resolve(response.data)
        })
        .catch(error => {
          if (axios.isCancel(error)) {
            reject(error)
            return
          }

          this.makeRequestWithGraphQLQuery(options)
            .then(response => {
              resolve(response.data)
            })
            .catch(error => {
              reject(error)
            })
        })
    })
  }

  makeRequestWithHash({ variables, operationName, requestHash, endpointModifier, cancelToken }) {
    const queryParams = convertVariablesToCacheableQueryString(variables).split('&').filter(Boolean)

    queryParams.push(`operation_name=${operationName}`)
    queryParams.push(`query_id=${requestHash}`)
    queryParams.push(`browser_id=${getUserTrackingData().uuid}`)
    queryParams.sort()

    return axios.get(this.getURLForRequestWithHash({ endpointModifier, queryParams }), { cancelToken })
  }

  getURLForRequestWithHash({ endpointModifier, queryParams }) {
    let url = this.endpoint

    if (endpointModifier) {
      url += `-${endpointModifier}`
    }

    url += '-x'

    if (queryParams.length) {
      url += `?${queryParams.join('&')}`
    }

    return url
  }

  makeRequestWithGraphQLQuery({ variables, operationName, query, endpointModifier, requestHash }) {
    const data = {
      variables,
      operation_name: operationName,
      query,
      browser_id: getUserTrackingData().uuid
    }

    return axios.post(this.getURLForRequestWithGraphQLQuery({ endpointModifier }), data, {
      headers: {
        'content-type': 'application/json',
        'X-Cache-Request-Hash': requestHash
      }
    })
  }

  getURLForRequestWithGraphQLQuery({ endpointModifier }) {
    let url = this.endpoint

    if (endpointModifier) {
      url += `-${endpointModifier}`
    }

    return url
  }
}
